import React, { useContext, useState } from 'react';
import { useRepeatedSection } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import CoTrusteePIDetails from './CoTrusteePIDetails';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const CoTrusteePISection = () => {
  const {
    appState: {
      store: {
        app: { coTrustees = [] }
      }
    },
    formProps: {
      coTrusteeFirstName,
      coTrusteeMiddleName,
      coTrusteeLastName,
      coTrusteeDob,
      coTrusteeCitizenship,
      coTrusteeSsn
    }
  } = useContext(FlowContext);

  const defaults = {
    people: coTrustees.map(cotrust => ({
      [coTrusteeFirstName.name]: cotrust?.name?.firstName,
      [coTrusteeMiddleName.name]: cotrust?.name?.middleName,
      [coTrusteeLastName.name]: cotrust?.name?.lastName,
      [coTrusteeDob.name]: cotrust?.dob,
      [coTrusteeCitizenship.name]: cotrust?.citizenship,
      [coTrusteeSsn.name]: cotrust?.taxID
    }))
  };

  const { sections, addSection } = useRepeatedSection('people', defaults);
  const [sectionAdded, setSectionAdded] = useState(!!coTrustees.length);

  const handleAddSection = () => {
    if (sectionAdded || coTrustees.length) {
      addSection();
    } else {
      setSectionAdded(true);
    }
  };

  return (
    <>
      <div className="add-section-button">
        Co-Trustee (optional)
        <hr />
        {sections && (
          <MFBeaconButton
            type="button"
            id="addCoTrusteeBtn"
            data-name={generateGeneralTestID('CoTrustPI', 'AddCoTrustButton')}
            onClick={handleAddSection}
            variant="tertiary"
            label="+ Add Co-Trustee"
          />
        )}
      </div>
      <div className="sections">
        {sectionAdded &&
          sections?.map(({ key, getDefault, makeName, removeSection }) => {
            return (
              <CoTrusteePIDetails
                key={key}
                getDefault={getDefault}
                makeName={makeName}
                removeSection={removeSection}
              />
            );
          })}
      </div>
    </>
  );
};

export default CoTrusteePISection;
